export default "__VITE_ASSET__e605d137__"